<!--
/*******************************************************************************
*@ 컴포넌트명   : PushNotiAcnoStupPopup.vue
*@ 컴포넌트설명 : Push알림계좌설정팝업
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <!--계좌설정-->
    <popup
      :opened.sync="isAcnoPopupOpen"
      :use-header="true"
      :use-footer="true"
      :useTopBorder="false"
      :btnAreaPadding="true"
      title="MPSH-03-01-01-04"
      class="bg-gray"
    >
      <template #content>
        <!-- 계좌정보 -->
        <div
          class="box-white -type4 setting"
          v-for="list of pushNotiAcnoStupInfo.dataGrid"
          :key="list.i"
        >
          <div class="header">
            <div class="title">{{ list.acnoAls }}</div>
            <div class="desc">
              <div class="item account">{{ list.acno }} - {{list.acnOtPutNm}}</div>
            </div>
            <div class="form-switch">
              <input
                type="checkbox"
                class="form-check-input"
                true-value="1"
                false-value="0"
                v-model="list.cnsntYn"
              />
              <span class="slider round"></span>
            </div>
          </div>
        </div>
        <!--// end -->
      </template>
      <template #footer>
        <button class="btn md normal" @click="setRcdrwCnsntYn()">
          <!--확인-->
          {{$t("MPSH-01-01-00-02")}}
        </button>
      </template>
    </popup>
  </article>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  props: ["opened"],
  mounted() {},
  created() {},

  data() {
    return {};
  },
  computed: {
    ...mapFields("customer/pushNotiStup", ["pushNotiStupInfo", "pushNotiAcnoStupInfo"]),
    isAcnoPopupOpen: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
  },
  methods: {
    setRcdrwCnsntYn() {
      let cnt = 0;
      for (let i = 0; i < this.pushNotiAcnoStupInfo.acnoCnt; i++) {
        if (this.pushNotiAcnoStupInfo.dataGrid[i].cnsntYn == "1") {
          cnt = cnt + 1;
        }
      }

      // 수신설정이 1건이라도 있으면 입출금알림 ON
      this.pushNotiAcnoStupInfo.totalCnt = cnt;
      if (this.pushNotiAcnoStupInfo.totalCnt > 0) {
        this.$set(this.pushNotiStupInfo, "rcdrwCnsntYn", "1");
        this.$set(this.pushNotiStupInfo, "pushRecvCnsntYn", "1");
      } else {
        this.$set(this.pushNotiStupInfo, "rcdrwCnsntYn", "0");
      }

      this.isAcnoPopupOpen = false;
    },
  },
};
</script>
